import { t } from 'i18next';
import { ApiError } from './ApiError';
import { ConcurrencyError, ErrorResponse } from '@/errorHandling';

export function isSemanticError(error: Error): error is SemanticError {
  return error.constructor === SemanticError;
}

export class SemanticError extends ApiError {
  constructor(response: Response, errorResponse?: ErrorResponse) {
    super(response, errorResponse);
  }

  static async create(response: Response) {
    const errorResponse = await super.extractError(response);

    const newError =
      errorResponse.errorType === 'PtwConcurrencyException'
        ? new ConcurrencyError(response, errorResponse)
        : new SemanticError(response, errorResponse);

    newError.message =
      (errorResponse.i18n && t(errorResponse.i18n.key, errorResponse.i18n.parameters)) ||
      errorResponse.message ||
      `${t('Error.Category.SemanticError.title')}. ${t('Error.Category.SemanticError.message')}`;

    return newError;
  }
}
